var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "q-list",
              { staticClass: "rounded-borders", attrs: { bordered: "" } },
              [
                _c(
                  "q-expansion-item",
                  {
                    attrs: {
                      dense: "",
                      dark: "",
                      "default-opened": "",
                      icon: "account_tree",
                      "header-class": "bg-blue-grey-6 text-white",
                      "expand-icon-class": "text-white",
                      label: "공정 정보",
                    },
                  },
                  [
                    _c("q-separator"),
                    _c("q-card", { staticClass: "q-pa-sm" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 col-md-3" },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "평가대상공정",
                                value: _vm.process.processName,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 col-md-3" },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "작업발생주기",
                                value: _vm.process.workCycleName,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 col-md-3" },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "작업시간(1회)",
                                value: _vm.process.workingTime,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "시나리오 목록",
            columns: _vm.grid.columns,
            gridHeight: _vm.setheight,
            data: _vm.process.fmScenarios,
            merge: _vm.grid.merge,
            filtering: false,
            columnSetting: false,
            usePaging: false,
            editable: _vm.editable && !_vm.disabled,
            selection: "multiple",
            rowKey: "ram4mAssessScenarioId",
          },
          on: {
            callbackProxy: _vm.callbackProxy,
            "table-data-change": _vm.tableDataChange,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "customCol"
                    ? [
                        !_vm.param.vendorFlag
                          ? [
                              props.row["sopImprovementIds"] &&
                              props.row["ibmStepNames"]
                                ? _vm._l(
                                    _vm.$comm.ibmTagItems(
                                      props.row,
                                      _vm.colorItems
                                    ),
                                    function (item, index) {
                                      return _c(
                                        "q-chip",
                                        {
                                          key: index,
                                          staticStyle: {
                                            "margin-bottom": "4px !important",
                                          },
                                          attrs: {
                                            color: item.color,
                                            clickable: true,
                                            "text-color": "white",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.linkClick(
                                                item,
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.title) + " "
                                          ),
                                          _c("c-assess-tooltip", {
                                            attrs: {
                                              ibmTooltip: item.ibmTooltip,
                                              ibmClassCd: item.ibmClassCd,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  )
                                : void 0,
                              _vm.editable &&
                              Boolean(props.row.ram4mAssessScenarioId) &&
                              props.row.editFlag !== "C" &&
                              !_vm.disabled
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "q-btn-group",
                                        {
                                          staticClass: "ColumInnerBtnGroup",
                                          attrs: { outline: "" },
                                        },
                                        [
                                          _c(
                                            "q-btn",
                                            {
                                              staticClass: "ColumInnerBtn",
                                              attrs: {
                                                icon: "add",
                                                color: "red-6",
                                                "text-color": "white",
                                                align: "center",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.innerBtnClicked(
                                                    col,
                                                    props,
                                                    "1"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("q-tooltip", [
                                                _vm._v(" 개선요청등록 "),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-btn",
                                            {
                                              staticClass: "ColumInnerBtn",
                                              attrs: {
                                                icon: "add",
                                                color: "light-blue",
                                                "text-color": "white",
                                                align: "center",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.innerBtnClicked(
                                                    col,
                                                    props,
                                                    "2"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("q-tooltip", [
                                                _vm._v(" 즉시조치등록 "),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          : [
                              props.row["ram4mAssessImprIds"] &&
                              props.row["stepFlagNames"]
                                ? _vm._l(
                                    _vm.$comm.fmImprTagItems(props.row),
                                    function (item, index) {
                                      return _c(
                                        "q-chip",
                                        {
                                          key: index,
                                          staticStyle: {
                                            "margin-bottom": "4px !important",
                                          },
                                          attrs: {
                                            color: item.color,
                                            clickable: true,
                                            "text-color": "white",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.linkClick(
                                                item,
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.title) + " "
                                          ),
                                          _c("c-assess-tooltip", {
                                            attrs: {
                                              isVendor: "",
                                              ibmTooltip: item.ibmFmTooltip,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  )
                                : void 0,
                              _vm.editable &&
                              Boolean(props.row.ram4mAssessScenarioId) &&
                              props.row.editFlag !== "C" &&
                              !_vm.disabled
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "q-btn-group",
                                        {
                                          staticClass: "ColumInnerBtnGroup",
                                          attrs: { outline: "" },
                                        },
                                        [
                                          _c(
                                            "q-btn",
                                            {
                                              staticClass: "ColumInnerBtn",
                                              attrs: {
                                                icon: "add",
                                                color: "red-6",
                                                "text-color": "white",
                                                align: "center",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.innerBtnClicked(
                                                    col,
                                                    props
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("q-tooltip", [
                                                _vm._v(" 개선등록 "),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                      ]
                    : col.name === "picture"
                    ? [
                        _c("q-btn", {
                          staticClass: "tableinnerBtn",
                          attrs: {
                            flat: "",
                            align: "center",
                            color: "blue-6",
                            label: "",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.openPicture(props, col)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function () {
                                  return [
                                    props.row.editFlag !== "C"
                                      ? [_vm._v(" 사진 ")]
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-update-btn", {
                    attrs: {
                      name: "updateBtn",
                      data: _vm.updateBtnData,
                      btnEditable: _vm.btnEditable,
                      flagCondition: _vm.flagCondition,
                    },
                    on: { back: _vm.back },
                  }),
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: { label: "삭제", icon: "remove" },
                        on: { btnClicked: _vm.removeScenario },
                      })
                    : _vm._e(),
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          isSubmit: _vm.isSave,
                          url: _vm.saveUrl,
                          param: _vm.process.fmScenarios,
                          mappingType: "PUT",
                          label: "저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveScenario,
                          btnCallback: _vm.saveScenarioCallback,
                        },
                      })
                    : _vm._e(),
                  _c("c-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.editable && !_vm.disabled && !_vm.btnEditable,
                        expression: "editable&&!disabled&&!btnEditable",
                      },
                    ],
                    attrs: {
                      isSubmit: _vm.isComplete,
                      url: _vm.completeUrl,
                      param: _vm.process,
                      mappingType: "PUT",
                      label: "공정[" + _vm.process.processName + "] 평가완료",
                      icon: "check",
                    },
                    on: {
                      beforeAction: _vm.completeProcess,
                      btnCallback: _vm.completeProcessCallback,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }